<svg version="1.1" class="blob" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 530 535" enable-background="new 0 0 530 535" xml:space="preserve">
<path id="blob-1" fill-rule="evenodd" clip-rule="evenodd" fill="#EEF4FB" d="M232.77,531.77c-44.76,6.07-81.34,4.92-115.05-15.03
	c-24.98-14.78-44.18-35.65-60.6-59.23C29.48,417.79,9.41,374.89,1.6,326.6c-5.98-36.96,4.92-59.73,31.71-85.24
	c15.87-15.1,32.09-29.82,47.76-45.12c22.34-21.82,37.28-48.9,52.5-75.74c14.28-25.19,28.31-50.47,47.09-72.82
	c28.07-33.41,64.02-51.84,105.9-46.24c45.61,6.1,86.84,24.13,126.18,47.06c30.39,17.72,58.68,38.17,81.16,65.76
	c23.43,28.75,35.1,61.94,35.99,98.82c1.72,71.27-16.9,137.18-54.23,197.62c-23.93,38.75-58.75,65.02-100.91,80.7
	c-28.09,10.44-57.09,18.52-85.94,26.72C267.97,524.04,246.7,528.42,232.77,531.77z"/>
</svg>
